import { combineReducers, Reducer } from 'redux';

import userReducer from 'redux/modules/user/slice';
import dashboardReducer from 'redux/modules/dashboard/slice';
import filterReducer from 'redux/modules/filter/slice';
import expenseReducer from 'redux/modules/expense/slice';
import budgetReducer from 'redux/modules/budget/slice';
import usersReducer from 'redux/modules/users/slice';
import zipsReducer from 'redux/modules/zips/slice';
import appReducer from 'redux/modules/app/slice';
import plantMappersReducer from 'redux/modules/master/plantmappers/slice';
import regionReducer from 'redux/modules/master/region/slice';
import ManufacturesReducer from 'redux/modules/master/manufactures/slice';
import DistributorsReducer from 'redux/modules/master/distributors/slice';
import HqfilterReducer from 'redux/modules/master/hqfilter/slice';
import DistributorRepMapperReducer from 'redux/modules/master/distributorRepMapper/slice';
import GoalSettingsReducer from 'redux/modules/master/goalsettings/slice';
import EndUserReducer from 'redux/modules/master/enduser/slice';
import VerificationReducer from 'redux/modules/verifications/slice';
import UploadsReducer from 'redux/modules/uploads/slice';
import territoryCodeMapperReducer from 'redux/modules/master/territoryCodeMapper/slice';
import mfgLookupReducer from './modules/mfgLookup/slice';
import PipelinePartNumberMapperReducer from './modules/master/pipelinePartnumberMapper/slice';
import DistributorManagerReducer from './modules/master/distributorManagerList/slice';
import ProductsReducer from './modules/master/product/slice';
import ForecastsReducer from './modules/master/forecast/slice';
import dealsReducer from './modules/deals/slice';
import SchedulerReducer from './modules/scheduler/slice';

import { RootState } from 'types';

const rootReducer: Reducer<RootState> = combineReducers<RootState>({
    userState: userReducer,
    dashboard: dashboardReducer,
    filter: filterReducer,
    expense: expenseReducer,
    budget: budgetReducer,
    users: usersReducer,
    zips: zipsReducer,
    app: appReducer,
    plantMappers: plantMappersReducer,
    region: regionReducer,
    manufactures: ManufacturesReducer,
    distributors: DistributorsReducer,
    hqfilter: HqfilterReducer,
    distributorRepMapper: DistributorRepMapperReducer,
    goalSettings: GoalSettingsReducer,
    endUser: EndUserReducer,
    verifications: VerificationReducer,
    history: UploadsReducer,
    territoryCodeMapper: territoryCodeMapperReducer,
    mfgLookup: mfgLookupReducer,
    PipelinePartNumberMapper: PipelinePartNumberMapperReducer,
    distributorManagers: DistributorManagerReducer,
    products: ProductsReducer,
    forecasts: ForecastsReducer,
    dealsState: dealsReducer,
    schedulers: SchedulerReducer,
});

export default rootReducer;
